import { AxiosError, AxiosInstance, AxiosResponse } from 'axios';
import { getExceptionFromAxiosError } from '../helpers';
import {
  AccountVariable,
  AccountVariableType,
  SaveAccountVariableRequest,
} from './types/account-variable.type';

export const accountVariablesService = (client: AxiosInstance) => {
  const BASE_URL = (accountId: string) => `/accounts/${accountId}/variables`;

  const getAccountVariables = async (
    accountId: string,
  ): Promise<AccountVariable[]> => {
    try {
      const result = await client.get<
        AccountVariable[],
        AxiosResponse<AccountVariable[]>
      >(BASE_URL(accountId), {
        withCredentials: true,
      });

      return result.data;
    } catch (e) {
      throw getExceptionFromAxiosError(e as AxiosError);
    }
  };

  const saveAccountVariable = async (
    accountId: string,
    type: AccountVariableType,
    request: SaveAccountVariableRequest,
  ): Promise<AccountVariable> => {
    try {
      const result = await client.put<
        AccountVariable,
        AxiosResponse<AccountVariable>
      >(`${BASE_URL(accountId)}/${type}`, request, {
        withCredentials: true,
      });

      return result.data;
    } catch (e) {
      throw getExceptionFromAxiosError(e as AxiosError);
    }
  };

  return {
    getAccountVariables,
    saveAccountVariable,
  };
};
